module.exports = __webpack_public_path__ + "img/quanyuan.39024d95.jpg";